const markdownQuoter = (str: string) => {
  const lines = str.split(/\n/);
  return `> ${lines.join('\n> ')}`;
};

export default markdownQuoter;
